import { getWebInstrumentations, initializeFaro, LogLevel, ReactIntegration, } from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { resolveFaroSettings } from "../config/options.js";
import { redactTransportItem } from "../privacy/redaction.js";
/**
 * Console levels that are not reported. Only warn and error reach Faro, the
 * same policy as the backend log pipeline (info and debug never reach Loki).
 */
const DISABLED_CONSOLE_LEVELS = [
    LogLevel.TRACE,
    LogLevel.DEBUG,
    LogLevel.LOG,
    LogLevel.INFO,
];
let activeFaro;
/** The running Faro instance, or undefined before `initFaro` / when Faro is off. */
export function getActiveFaro() {
    return activeFaro;
}
function buildInstrumentations(settings, router) {
    const instrumentations = [
        ...getWebInstrumentations({ captureConsole: true }),
        router ? new ReactIntegration({ router }) : new ReactIntegration(),
    ];
    if (settings.tracingEnabled) {
        instrumentations.push(new TracingInstrumentation({
            instrumentationOptions: { propagateTraceHeaderCorsUrls: settings.traceCorsUrls },
            omitTraceContextForUnsampledSessions: true,
        }));
    }
    return instrumentations;
}
/**
 * Starts Grafana Faro (frontend observability) for a React app: errors, web
 * vitals, sessions, page views, route changes, warn/error console output,
 * and browser traces for fetch/XHR calls that join the backend traces.
 *
 * Call once, before the app renders. Returns undefined (and does nothing)
 * without a collector URL. URLs are redacted before sending; no user data is
 * attached unless `setFaroUser` is called.
 *
 * `router` is optional. When omitted the ReactIntegration is still active
 * (for error boundary capture) but route changes are not tracked automatically.
 * Call `trackRouteChanges()` after init to enable History API-based route
 * tracking without touching the router.
 */
export function initFaro(options, router) {
    if (activeFaro)
        return activeFaro;
    const settings = resolveFaroSettings(options);
    if (!settings)
        return undefined;
    activeFaro = initializeFaro({
        url: settings.collectorUrl,
        app: { ...settings.app },
        instrumentations: buildInstrumentations(settings, router),
        consoleInstrumentation: { disabledLevels: DISABLED_CONSOLE_LEVELS },
        ignoreUrls: settings.ignoreUrls,
        sessionTracking: {
            enabled: true,
            persistent: true,
            samplingRate: settings.sessionSampleRate,
        },
        trackGeolocation: false,
        beforeSend: redactTransportItem,
    });
    return activeFaro;
}
//# sourceMappingURL=initialize.js.map